import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import Link from "arena/components/Link";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useArena } from "core/components/ArenaProvider";
import getShelfLinkProps from "core/utils/getShelfLinkProps";

export default function HeaderMoreLink({ url }) {
  const { t } = useTranslation("arena");
  const arena = useArena();
  const { isExternal, to, href } = getShelfLinkProps(url, arena.url);

  const iconButton = isExternal ? (
    <IconButton
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      size="medium"
    >
      <ArrowForwardIcon />
    </IconButton>
  ) : (
    <IconButton component={Link} to={to} size="medium">
      <ArrowForwardIcon />
    </IconButton>
  );

  return <Tooltip title={t("headerMoreLink.showAll")}>{iconButton}</Tooltip>;
}

HeaderMoreLink.propTypes = {
  url: PropTypes.string,
};
